import { computed, onBeforeUnmount, onMounted, watch } from 'vue';
import { NOTIFICATION_GROUPINGS } from '@/constants';
import { useWebPush } from '@/utils/composables/useWebPush';
import { useNotificationsUnviewedUnreadCount } from '@/utils/swr';
import { useStore } from '@/utils/vue';

export const useUnviewedNotifications = () => {
  const store = useStore();
  const { canReceiveWebPushNotification } = useWebPush();

  const { data: unviewedUnreadCountData, mutate: mutateUnviewedUnreadCount } =
    useNotificationsUnviewedUnreadCount(NOTIFICATION_GROUPINGS);

  // 残未閲覧のセット
  const setViewedNotification = () => {
    if (unviewedUnreadCountData.value) {
      // オブジェクト内のunviewed_countの合計を取得して通知の未閲覧数を得る
      const unviewedCount = Object.values(
        unviewedUnreadCountData.value.counts,
      ).reduce((acc, cur) => {
        return acc + cur.unviewed_count;
      }, 0);
      store.commit(
        'notification/setUnviewedUnreadCountData',
        unviewedUnreadCountData.value,
      );
      store.commit('notification/setUnviewedCount', unviewedCount);
      store.commit('notification/setHasUnviewed', !!unviewedCount);
    }
  };

  // unviewdUnreadCountDataのfetchが完了したら残未読数をセットする
  watch(unviewedUnreadCountData, setViewedNotification, { immediate: true });

  /** Web Push通知を受け取ったときのハンドラー */
  const handleWebPushNotificationMessageEvent = async (event: MessageEvent) => {
    if (event.data.type === 'notification-received') {
      await mutateUnviewedUnreadCount();
    }
  };

  onMounted(() => {
    if (canReceiveWebPushNotification()) {
      navigator.serviceWorker.addEventListener(
        'message',
        handleWebPushNotificationMessageEvent,
      );
    }
  });

  onBeforeUnmount(() => {
    if (canReceiveWebPushNotification()) {
      navigator.serviceWorker.removeEventListener(
        'message',
        handleWebPushNotificationMessageEvent,
      );
    }
  });

  const hasUnviewedNotification = computed(
    () => store.state.notification.hasUnviewed,
  );

  return {
    hasUnviewedNotification,
    refetch: () => mutateUnviewedUnreadCount(),
  };
};
